import { Loadable } from 'utils/components'

export default Loadable({
  loader: () => import('./Footer')
})
